module.exports = __webpack_public_path__ + "static/img/item-3-1-big.963f07a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-3-1-big.png
// module id = cLYL
// module chunks = 2